<div class="search">
  <mat-form-field appearance="outline">
    <input
      [(ngModel)]="searchTerm"
      matInput
      placeholder="Pesquisar"
      (keyup)="applyFilter()"
    />
    <mat-icon class="icon-search" matSuffix>search</mat-icon>
  </mat-form-field>
</div>

<div class="container">
  <section *ngFor="let contact of displayedItems">
    <ng-template #bottomSheetContent> </ng-template>

    <div class="row row-content mt-4">
      <div class="col-6 mb-3">
        <p class="title">Nome</p>
        <p class="description link">{{ contact.senderReceiverName }}</p>
      </div>
      <div class="col-6 mb-3">
        <p class="title">País</p>
        <p class="description">
          {{ contact?.country?.description }}
        </p>
      </div>

      <div class="col-6 mb-3">
        <p class="title">Moeda</p>
        <p class="description">
          {{ getCurrencyDescription(contact.currency) }}
        </p>
      </div>

      <div class="col-6 mb-3">
        <p class="title">Tipo de contato</p>

        <p class="description" *ngIf="contact?.type == 'ReceiverAccount'">
          Beneficiário
        </p>
        <p class="description" *ngIf="contact?.type == 'SenderAccount'">
          Pagador
        </p>
      </div>
    </div>

    <div class="d-flex justify-content-center mt-4 btn-action">
      <!-- <p class="description" *ngIf='order?.statusFlow == "PROCESSING" || order?.statusFlow == "CANCELED" || order?.statusFlow == "IDENTIFYING_PAYMENT" || order?.statusFlow == "IDENTIFIED_PAYMENT" || order?.statusFlow == "PAID"'>-</p>
      <p class="description" *ngIf='order?.statusFlow == "AVAILABLE_PAYMENT" && order?.remmitanceType == "INBOUND"'>-</p> -->
    </div>
  </section>

  <div class="d-flex justify-content-center mt-1">
    <mat-paginator
      (page)="changePage($event)"
      [pageIndex]="pageIndex"
      [pageSizeOptions]="pageSizeOptions"
      [pageSize]="pageSize"
      [length]="filteredItems.length"
    ></mat-paginator>
  </div>
</div>
